// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nform > * + *[data-v-416020ac] {\n    margin-top: 20px;\n}\ninput[data-v-416020ac] {\n    border: 0px solid;\n}\n\n", ""]);
// Exports
module.exports = exports;
